<template>
  <div class="work-order-analysis">
    <div class="monitoring-status">
      <el-card class="card">
        <Monitoring :form="form"></Monitoring>
      </el-card>
      <el-card class="card">
        <Status  :form="form"></Status>
      </el-card>
    </div>
    <el-card class="completion-status">
      <Completion  :form="form"></Completion>
    </el-card>
  </div>
</template>
<script>
import Monitoring from "./Monitoring.vue"
import Status from "./Status.vue"
import Completion from "./Completion.vue"

export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Monitoring,
    Completion,
    Status,
  },
}
</script>

<style scoped lang="scss">
.work-order-analysis {
  ::v-deep(.el-card__header) {
    border-bottom: 0 !important;
    padding: 15px;
  }
  ::v-deep(.el-card__body) {
    padding: 16px;
  }
  .monitoring-status {
    display: flex;
    justify-content: space-between;
    .card {
      width: 49.3%;
      border-radius: 10px;
    }
  }
  .completion-status {
    margin-top: 20px;
    border-radius: 10px;
  }
}
</style>
